import { render } from "./TicketsCard.vue?vue&type=template&id=283ed7d5&scoped=true"
import script from "./TicketsCard.vue?vue&type=script&lang=js"
export * from "./TicketsCard.vue?vue&type=script&lang=js"

import "./TicketsCard.vue?vue&type=style&index=0&id=283ed7d5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283ed7d5"]])

export default __exports__